export { default as Provider } from './Provider';

export { default as connect } from './connect';

export { default as create } from './create';


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/_util/store/index.js
// module id = 137
// module chunks = 0